module.exports = __webpack_public_path__ + "img/img2.ae647cc1.png";